export default {
  plural: 'Twins',
  singular: 'Twin',
  create: 'Створити twin',
  code: 'Код',
  name: 'Назва',
  integrationCodes: {
    title: 'Коди інтеграцій',
    hint: 'Як цю опцію називає зовнішній магазин — артикул, ідентифікатор терма атрибута тощо. Віджет адресується за ними, а не за нашими кодами.',
    addRow: 'Додати код'
  },
  status: {
    draft: 'Чернетка',
    published: 'Опубліковано',
    deactivated: 'Деактивовано'
  },
  searchPlaceholder: 'Пошук twin за назвою',
  workspace: {
    publish: 'Опублікувати',
    comingSoon: 'Незабаром',
    tabs: {
      variants: 'Варіанти',
      parts: 'Слоти та деталі',
      materials: 'Зони та матеріали',
      rules: 'Правила',
      preview: 'Превʼю'
    }
  },
  simple: {
    steps: {
      model: 'Модель',
      parts: 'Деталі',
      materials: 'Матеріали'
    },
    notConfigured: 'не вибрано',
    title: 'Простий режим'
  },
  variants: {
    plural: 'Варіанти',
    addVariant: 'Додати варіант',
    createTitle: 'Базова модель',
    editTitle: 'Базова модель',
    deleteTitle: 'Видалити варіант',
    deleteWarning: 'Ви впевнені, що хочете видалити цей варіант?',
    defaultLabel: 'За замовчуванням',
    setDefault: 'Варіант за замовчуванням',
    product: 'CRM-продукт',
    baseModel: 'Базова модель',
    noVariants: 'Варіантів поки немає',
    changeBaseModel: 'Замінити модель',
    noBaseModel: 'Базову модель не вибрано'
  },
  parts: {
    createTitle: 'Додати деталь',
    addPart: 'Додати деталь',
    save: 'Зберегти',
    remove: 'Прибрати',
    glbAsset: 'GLB-ассет',
    noVariants: 'Спочатку створіть варіант',
    noBaseModel: 'У цього варіанта ще немає базової моделі',
    noSockets: 'У базової моделі немає сокетів',
    noParts: 'Деталі не призначені',
    noConnector: 'У деталі немає конектора, неможливо призначити:',
    compatible: 'Сумісно',
    existingGlbAsset: 'Існуючий ассет',
    uploadNewGlbAsset: 'Завантажити новий GLB',
    newGlbAssetName: 'Новий GLB-ассет'
  },
  library: {
    searchPlaceholder: 'Пошук у бібліотеці',
    empty: 'У бібліотеці поки порожньо',
    noGlb: 'GLB не прикріплено',
    noProduct: 'Без продукту'
  },
  socketPanel: {
    title: 'Правила сокета',
    modeLabel: 'Режим сокета',
    acceptByRule: 'Автодобір за правилами',
    curatedOnly: 'Лише вибрані деталі',
    candidates: 'Підсумкові кандидати',
    noCandidates: 'Віджет поки не резолвить кандидатів для цього сокета',
    candidatesHint:
      'Те, що реально запропонує віджет — з живого viewer-пейлоада',
    patternAffects: 'Цей паттерн розповсюдиться на',
    prefixOverMatchWarning:
      'socketPattern завжди матчиться як префікс — правило також охопить',
    socketsTitle: 'Сокети моделі',
    searchPlaceholder: 'Пошук сокета...',
    selectSocket: 'Оберіть сокет ліворуч, щоб налаштувати його деталі',
    assignedTitle: 'Призначені деталі',
    assignedHint: 'Зберігаються кнопкою «Зберегти» нижче',
    inheritedTitle: 'Надходять із правил',
    inheritedHint:
      'Резолвляться віджетом за правилами — додайте, щоб редагувати локально',
    modeHintAcceptByRule:
      'Деталі, що підходять за правилами, додаються поверх призначених.',
    modeHintCuratedOnly:
      'У сокеті залишаться лише явно призначені деталі, правила нічого не додадуть.',
    modeSavesImmediately: 'зберігається одразу',
    nestedOn: 'на',
    emptySocket: 'Сокет порожній — призначте хоча б одну деталь.',
    configuredCount: 'налаштовано'
  },
  sections: {
    base: 'Базова модель',
    slots: 'Слоти та деталі',
    materials: 'Зони та матеріали',
    rules: 'Правила',
    preview: "Прев'ю та публікація",
    copyId: 'Копіювати id конфігуратора',
    copied: 'Скопійовано'
  },
  wizard: {
    title: 'Новий твін',
    stepBase: 'Основа',
    next: 'Далі',
    back: 'Назад',
    finish: 'Завершити',
    createAndContinue: 'Створити та продовжити',
    fromLibrary: 'З бібліотеки',
    uploadNew: 'Завантажити новий GLB',
    basisRequired: 'Оберіть або завантажте базову модель',
    productRequired: 'Потрібен продукт CRM',
    companyRequired: 'Потрібна компанія',
    nameRequired: 'Потрібна назва',
    codeRequired: 'Потрібен код'
  },
  crm: {
    sectionTitle: '3D',
    rolePart: 'Деталь',
    roleVariant: 'Основа',
    usedInConfigurators: 'Використовується в конфігураторах',
    notUsed: 'Поки не використовується в конфігураторах',
    usageMayBeIncomplete:
      'Лічильники використання можуть бути неповними — записів більше, ніж вдалося завантажити.',
    listMayBeIncomplete:
      'Частина записів може не відображатися — їх більше, ніж вдалося завантажити.',
    empty: 'У продукту поки немає 3D-сутностей',
    materialsEmpty: 'У матеріалу поки немає twin-матеріалів',
    addModel: 'Додати 3D-модель',
    addTwinMaterial: 'Додати twin-матеріал',
    roleQuestion: 'Що це за модель?',
    companyLabel: 'Компанія твіна',
    configuratorLabel: 'Конфігуратор',
    createNewConfigurator: 'Потрібен новий конфігуратор? Відкрити візард'
  }
};
